import React from 'react';
import { Flex, Radio, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import type { SortOption } from '@shared/constants/accommodations';
import { useSortOptions } from '@apps/stays/AccommodationsConsole/hooks/useSortOptions';

type SortOptionsFacetProps = Readonly<{
  selectedValue: SortOption;
  onChange: (value: SortOption) => void;
  includeCouplesPicks: boolean;
  includeFundSavings?: boolean;
  accentColor?: string;
}>;

export const SortOptionsFacet: React.FC<SortOptionsFacetProps> = ({ selectedValue, onChange, includeCouplesPicks, includeFundSavings, accentColor }) => {
  const { sortOptions, sortTrans } = useSortOptions(includeCouplesPicks, includeFundSavings);

  return (
    <Flex
      flexDirection="column"
      gap={4}
    >
      <TextV2 typographyVariant="hed4">{sortTrans.title()}</TextV2>
      <Flex
        flexDirection="column"
        gap={3}
      >
        {sortOptions.map(option => (
          <Flex
            key={option.value}
            alignItems="center"
          >
            <Radio
              onChange={() => onChange(option.value)}
              id={`sort-${option.value.toLowerCase()}`}
              checked={selectedValue === option.value}
              value={option.value}
              activeColor={accentColor ?? '#4951EF'}
              name="sortBy"
              label={option.label}
              style={{ fontSize: pxToRem(16) }}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
